export { default as FitText } from './FitText';